import React from 'react'

const DialogForm = () => {
    const closePopup = () => { 

    }
    return (
        <>
            <div className='dialog-container'>
              <div className="popup" id='popup'>
                  <img src='/images/logos/proforum_main.jpg' alt='proforum' />
                  <h2>Thank you</h2>
                  <p>jdfjfjfjfjf</p>
                  <div>
                        <button onClick={closePopup } className="btn btn-danger" > Cancel</button>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <button
                          className="btn btn-success">
                          Confirm
                      </button>
                  </div>
              </div>
            </div>
        </>
    );
}

export default DialogForm